<template>
  <a-dropdown v-if="nickname" placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar size="small" :src="$url + avatar" class="antd-pro-global-header-index-avatar" v-if="avatar" />
      <span>{{ nickname }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <!-- <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="user" />
          个人中心
        </a-menu-item> -->
        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          个人设置
        </a-menu-item>
        <a-menu-item v-if="menu && (userTentant.type == 1 || userTentant.type == 2)" key="modifyTenant" @click="handleInfo" v-hasPermi="['system:tenant:query']">
          <a-icon type="setting" />
          {{ userTentant.type == 1 ? '修改企业' : '修改经销商' }}
        </a-menu-item>
        <!-- <template v-if="tenantListed && tenantListed.length !== 1">
          <a-menu-divider v-if="menu" />
          <a-menu-item v-if="menu" key="roleSwitch">
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                <a-icon type="setting" />
                切换角色
              </a>
              <a-menu slot="overlay">
                <a-menu-item
                  v-for="(item, index) in tenantListed"
                  :key="index"
                  :style="item.tenantId == tenantId ? ' background: #1890ff; color: #fff' : ''"
                >
                  <a @click="handleChoose(item, index)">
                    {{ item.type == 1 ? '企业品牌' : (item.type = 2 ? '经销商' : '区域') }}{{ item.tenantName }}
                  </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-menu-item>
        </template> -->
        <a-menu-divider v-if="menu" v-hasPermi="['1e63dea4c7366c2ca763666365791ffbb:b0:b']" />
        <a-menu-item key="storageSpace" @click="storageSpace" v-hasPermi="['1e63dea4c7366c2ca763666365791ffbb:b0:b']">
          <a-icon type="snippets" />

          存储空间
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          退出登录
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>
<script>
import { Modal } from 'ant-design-vue'
import { mapGetters } from 'vuex'
import Item from '../AvatarList/Item'
import { getUserProfile } from '@/api/system/user'
export default {
  name: 'AvatarDropdown',
  props: {
    menu: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['nickname', 'infoUser', 'userTentant']),
  },
  data() {
    return {
      avatar: '',
      tenantListed: [],
      tenantListeds: [],
      tenantId: '',
    }
  },
  created() {
    this.tenantId = this.userTentant.tenantId
    this.tenantListed = this.infoUser.tenantListed
    this.tenantListeds = JSON.parse(JSON.stringify(this.infoUser.tenantListed))
    this.getUser()
  },
  methods: {
    // 点击跳转个人设置页面
    handleToCenter() {
      this.$router.push({ path: '/account/center' })
    },

    getUser() {
      getUserProfile().then((response) => {
        // this.user = response.data
        this.avatar = response.data.avatar
        // this.roleGroup = response.roleGroup
        // this.postGroup = response.postGroup
      })
    },
    // 点击选择
    handleChoose(e, index) {
      const obj = this.tenantListeds[index]
      if (obj.type === '经销商') {
        obj.type = 2
      } else if (obj.type === '企业品牌') {
        obj.type = 1
      }
      localStorage.setItem('userTentant', JSON.stringify(obj))
      this.$store.commit('USE_RTENANT', obj)
      this.$store.commit('SET_PERMISSIONS', obj.permissions)
      this.$router.push({ path: '/' }).catch(() => {})
      this.$nextTick(() => {
        window.location.reload()
      })
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' })
    },
    storageSpace() {
      this.$router.push({ name: 'StorageDashboard' })
    },
    // 点击修改企业和经销商
    handleInfo() {
      this.$router.push({ path: '/account/Information' })
    },
    handleLogout(e) {
      var that = this
      Modal.confirm({
        title: '提示',
        content: '确定退出系统吗？',
        onOk: () => {
          return this.$store.dispatch('Logout').then((res) => {
            that.$router.push({ path: 'user/login' })
            location.href = '/'
            // that.$router.push({ name: 'login' })
          })
          // that.$router.push({ name: 'logout' })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }
  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}
</style>
